import { colorProp, highContrastProp, radiusProp } from '../helpers';
const sizes = ['1', '2', '3'];
const selectRootPropDefs = {
    size: { type: 'enum', values: sizes, default: '2', responsive: true },
};
const triggerVariants = ['classic', 'surface', 'soft', 'ghost'];
const selectTriggerPropDefs = {
    variant: { type: 'enum', values: triggerVariants, default: 'surface' },
    color: colorProp,
    radius: radiusProp,
};
const contentVariants = ['solid', 'soft'];
const selectContentPropDefs = {
    variant: { type: 'enum', values: contentVariants, default: 'solid' },
    color: colorProp,
    highContrast: highContrastProp,
};
export { selectRootPropDefs, selectTriggerPropDefs, selectContentPropDefs };
//# sourceMappingURL=select.props.js.map